module.exports = __webpack_public_path__ + "static/media/startimes.713cc080.png";